"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactDom = _interopRequireDefault(require("react-dom"));
require("./ripple.css");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
// Get coordinates of mouse or touch event relative to the element that was
// clicked or touched.
var getRelativeCoordinates = function getRelativeCoordinates(_ref) {
  var ev = _ref.ev,
    element = _ref.element;
  var bounds = element.getBoundingClientRect();
  var _ref2 = ev.touches ? ev.touches[0] : ev,
    pageX = _ref2.pageX,
    pageY = _ref2.pageY;
  return {
    x: pageX - (window.scrollX || window.pageXOffset) - bounds.left,
    y: pageY - (window.scrollY || window.pageYOffset) - bounds.top
  };
};
var Ripple = /*#__PURE__*/function (_Component) {
  _inherits(Ripple, _Component);
  var _super = _createSuper(Ripple);
  function Ripple() {
    var _this;
    _classCallCheck(this, Ripple);
    _this = _super.call(this);
    _this.state = {
      active: false,
      origin: {}
    };
    _this.activate = _this.activate.bind(_assertThisInitialized(_this));
    _this.handleAnimationEnd = _this.handleAnimationEnd.bind(_assertThisInitialized(_this));
    _this.mergeEventHandlers = _this.mergeEventHandlers.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(Ripple, [{
    key: "activate",
    value: function activate(ev) {
      var _this2 = this;
      // Return early if Ripple has been activated through a touchstart event
      // and is now being activated again by a mousedown. This prevents a double
      // event from the touchstart and mousedown listeners.
      //
      // Typically this wouldn't be necessary, because calling ev.preventDefault
      // on a touchstart event prevents the subsequent mousedown event from
      // firing. This doesn't work in React + Chrome at the moment because
      // Chrome sets touch listeners to passive by default (which doesn't
      // support preventDefault) and React does not yet provide a way to make
      // these listeners active again.
      if (this.state.active && this.touchStarted && ev.type === 'mousedown') {
        this.touchStarted = false;
        return;
      }
      this.touchStarted = ev.type === 'touchstart';
      var newState = {
        active: true,
        origin: getRelativeCoordinates({
          ev: ev,
          element: _reactDom["default"].findDOMNode(this)
        })
      };

      // Cancel current animation if it's running, then trigger a new one.
      if (this.state.active) {
        this.deactivate(function () {
          _this2.setState(newState);
        });
        return;
      }
      this.setState(newState);
    }
  }, {
    key: "deactivate",
    value: function deactivate(callback) {
      this.setState({
        active: false,
        origin: {}
      }, callback);
    }
  }, {
    key: "handleAnimationEnd",
    value: function handleAnimationEnd() {
      this.deactivate();
    }
  }, {
    key: "getEventHandlers",
    value: function getEventHandlers() {
      return {
        onMouseDown: this.activate,
        onTouchStart: this.activate
      };
    }
  }, {
    key: "mergeEventHandlers",
    value: function mergeEventHandlers(props) {
      var eventHandlers = this.getEventHandlers();
      var onTouchStart = props.onTouchStart,
        onMouseDown = props.onMouseDown;
      return {
        onTouchStart: onTouchStart ? function (ev) {
          eventHandlers.onTouchStart(ev);
          onTouchStart(ev);
        } : eventHandlers.onTouchStart,
        onMouseDown: onMouseDown ? function (ev) {
          eventHandlers.onMouseDown(ev);
          onMouseDown(ev);
        } : eventHandlers.onMouseDown
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        active = _this$state.active,
        origin = _this$state.origin;
      var defaultBgClass = this.props.dark ? 'bg-black50' : 'bg-white';
      var bgClass = this.props.backgroundClassName ? this.props.backgroundClassName : defaultBgClass;
      var ripple = active ? /*#__PURE__*/_react["default"].createElement("span", {
        className: "sb-ripple absolute ".concat(bgClass, " ").concat(this.props.className),
        onAnimationEnd: this.handleAnimationEnd,
        style: {
          top: origin.y || 0,
          left: origin.x || 0
        }
      }) : undefined;
      return this.props.children({
        ripple: ripple,
        eventHandlers: this.getEventHandlers(),
        mergeEventHandlers: this.mergeEventHandlers
      });
    }
  }]);
  return Ripple;
}(_react.Component);
Ripple.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Overrides the background class */
  backgroundClassName: _propTypes["default"].string,
  /**
   * Function returning properties used to render the ripple
   * and apply required event listeners to the ripple's parent.
   * Returns an object with the following properties:
   *
   * - `ripple`: The renderable React ripple element. Place within
   *   the element that should ripple. Note: the element containing
   *   the ripple must have `position: relative`. It can optionally
   *   use `overflow: hidden` to keep the ripple within the bounds
   *   of the element.
   * - `eventHandlers`: Event handlers used to enable ripples.
   *   Pass to the element that should ripple.
   * - `mergeEventHandlers`: A function used to create ripple event
   *   handlers merged with event handlers from element that should
   *   ripple. Takes `props` of target element as parameter, and returns
   *   `eventHandlers` object. This function is only necessary if the
   *   component using ripple must support its own `onTouchStart` and
   *   `onMouseDown` event handlers. Otherwise, just use the
   *   `eventHandlers` property.
   */
  children: _propTypes["default"].func.isRequired,
  /**
   * Inverts ripple color scheme, making it dark instead of light.
   */
  dark: _propTypes["default"].bool
} : {};
Ripple.defaultProps = {
  children: function children() {}
};
var _default = exports["default"] = Ripple;